// extracted by mini-css-extract-plugin
export var subtitle = "_az-2";
export var title = "_az-0";
export var titleNoWrap = "_az-1";